import { render } from "./stack_active_set_A.vue?vue&type=template&id=4c8422f7&scoped=true"
import script from "./stack_active_set_A.vue?vue&type=script&lang=js"
export * from "./stack_active_set_A.vue?vue&type=script&lang=js"

import "./stack_active_set_A.vue?vue&type=style&index=0&id=4c8422f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8422f7"]])

export default __exports__